export const byId = id => document.getElementById(id);

export const byClassName = (selector, ctx = document) => Array.toArray(ctx.getElementsByClassName(selector));

export const qs = (selector, ctx = document) => ctx.querySelector(selector);

export const qsa = (selector, ctx = document) => Array.from(ctx.querySelectorAll(selector));

export const data = (attr, ctx) => ctx.hasAttribute('data-' + attr) ? ctx.getAttribute('data-' + attr) : '';

// Class Helper

const hasClass = (selector, className) => { return selector.classList.contains(className) };

const addClass = (selector, className) => selector.classList.add(className);

const removeClass = (selector, className) => selector.classList.remove(className);

const toggleClass = (selector, className, toggle) => {
    const fn = toggle === undefined ? 'toggle' : (toggle ? 'add' : 'remove');
    cls[fn](selector, className);
};

export const cls = {
    has: hasClass,
    add: addClass,
    remove: removeClass,
    toggle: toggleClass
}

